import { render } from "./MarkedReturn.vue?vue&type=template&id=5af436c3"
import script from "./MarkedReturn.vue?vue&type=script&lang=js"
export * from "./MarkedReturn.vue?vue&type=script&lang=js"

import "./MarkedReturn.vue?vue&type=style&index=0&id=5af436c3&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__